import React, { useState } from "react";
import { useStyles } from "./HomeStyle";
import { CircularProgress, Grid, Typography } from "@material-ui/core/";
import OptionCard from "../../../components/optionCard/OptionCard";
import { Link } from "react-router-dom";
import teamIMG from "../../../assets/team.png";
import Controls from "../../../components/controls/Controls";
import RequestService from "../../../services/RequestService";
import { AppThemeRequestProvider } from "../../../context/ThemeRequestContext";
import TmpSkeletonLeftPageCustom from "../../../components/tempo/TmpSkeletonLeftPageCustom/TmpSkeletonLeftPageCustom";

export default function Home() {

  const classes = useStyles();

  const [requestsType, setRequestsType] = useState([])

  const useIsMounted = () => {
    const isMounted = React.useRef(false);
    React.useEffect(() => {
      isMounted.current = true;
      window.scrollTo(0, 0);

      RequestService.getAllRequests().then(e => {
        if (isMounted.current) {
          setRequestsType(e);
        }
      });

      return () => {
        isMounted.current = false;
      };
    }, []);
    return isMounted;
  };

  useIsMounted();

  return (
    <AppThemeRequestProvider>
      <Grid container>
        <Grid item xs={5}>

          <TmpSkeletonLeftPageCustom
            title={["Faça sua <br /> Solicitação de <br /> Cadastro"]}
            showImage={false}
            subTitle={" O Portal do SAM - Serviço de Apoio ao Médico é destinado aos profissionais que desejam fazer parte do corpo clínico do Sírio-Libanês e também para dar suporte as informações cadastrais dos profissionais."}
          />

          <Grid item xs={12}>
            <img
              src={teamIMG}
              alt="imagem ilustrativa de uma equipe médica feliz"
              style={{ width: "100%" }}
            />
          </Grid>

        </Grid>
        <Grid item xs={7}>
          <Grid container spacing={4} style={{ display: "flex", justifyContent: "center" }}>
            <Grid item>
              <Typography style={{ fontSize: "1.5em", color: "#000", fontWeight: "400", textAlign: "center", fontFamily: "Inter", lineHeight: 1.3 }}>
                Escolha a categoria do profissional da qual você deseja fazer parte e preencha o formulário de cadastro
              </Typography>
            </Grid>

            {requestsType === undefined || requestsType.length === 0 ?
              <Grid container justifyContent="center" style={{ width: "85%" }} >
                <CircularProgress />
              </Grid>
              : ""}

            {requestsType.map((item: any, index) => (
              <Grid item key={index} style={{ width: "85%" }}>
                <Link to={item.url} style={{ textDecoration: "none" }}>
                  <OptionCard
                    title={item.name}
                    subTitle={item.description}
                  />
                </Link>
              </Grid>
            ))}
            <Grid item style={{ width: "85%", textAlignLast: "end" }}>
              <Grid item className={classes.button}>
                <Link to="/" className={classes.link}>
                  <Controls.Button text="Voltar" type="Back" />
                </Link>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </AppThemeRequestProvider >
  );
}
